import processElementMotion from '../../utils/processElementMotion';
import motionWrapperComponents from './components';

function initMotionComponents() {
	if (motionWrapperComponents.length > 0) {
		motionWrapperComponents.map(component => processElementMotion(component));
	}
}

export default initMotionComponents;
